(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["buy-box"] && !Shopify.designMode) return;
  try {
    
  class BuyBoxGallery extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[ref="track"]');
      this.slides = this.querySelectorAll('.buy-box__slide');
      this.thumbs = this.querySelectorAll('[data-goto]');
      this.index = 0;

      this.querySelectorAll('[data-dir]').forEach((button) => {
        button.addEventListener('click', () => this.go(Number(button.dataset.dir)));
      });

      this.thumbs.forEach((thumb) => {
        thumb.addEventListener('click', () => this.select(Number(thumb.dataset.goto)));
      });

      // Keep thumbnails in step when the shopper swipes the track directly.
      if (this.track) {
        let frame;
        this.track.addEventListener(
          'scroll',
          () => {
            cancelAnimationFrame(frame);
            frame = requestAnimationFrame(() => {
              const width = this.track.clientWidth;
              if (!width) return;
              this.setActive(Math.round(this.track.scrollLeft / width));
            });
          },
          { passive: true }
        );
      }

      this.setActive(0);
    }

    go(step) {
      if (!this.slides.length) return;
      this.select((this.index + step + this.slides.length) % this.slides.length);
    }

    select(index) {
      if (!this.track || !this.slides.length) return;
      this.track.scrollTo({ left: this.track.clientWidth * index, behavior: 'smooth' });
      this.setActive(index);
    }

    setActive(index) {
      this.index = index;
      this.thumbs.forEach((thumb, position) => {
        thumb.setAttribute('aria-current', position === index ? 'true' : 'false');
      });
    }
  }

  if (!customElements.get('buy-box-gallery')) {
    customElements.define('buy-box-gallery', BuyBoxGallery);
  }

  document.querySelectorAll('.buy-box').forEach((root) => {
    const form = root.querySelector('product-form-component');
    const hidden = form?.querySelector('input[name="id"]');
    const cta = form?.querySelector('[ref="addToCartButton"]');

    const setCtaLabel = (button, text) => {
      if (!button || !text) return;
      let updated = false;
      button.childNodes.forEach((node) => {
        if (node.nodeType === Node.TEXT_NODE && node.textContent.trim().length > 0) {
          node.textContent = ` ${text} `;
          updated = true;
        }
      });
      if (!updated) {
        const added = button.querySelector('.add-to-cart__added');
        button.insertBefore(document.createTextNode(` ${text} `), added);
      }
    };

    root.querySelectorAll('input[name^="buy-box-supply-"]').forEach((input) => {
      input.addEventListener('change', () => {
        if (!input.checked) return;
        root.querySelectorAll('.buy-box__supply').forEach((card) => card.classList.remove('is-selected'));
        input.closest('.buy-box__supply')?.classList.add('is-selected');
        if (hidden) hidden.value = input.dataset.variantId;
        if (cta) {
          cta.disabled = input.dataset.available !== 'true';
          setCtaLabel(cta, input.dataset.cta);
        }
      });
    });

    root.querySelectorAll('[data-addon-id]').forEach((button) => {
      button.addEventListener('click', async () => {
        const id = button.dataset.addonId;
        if (!id) return;
        button.disabled = true;
        try {
          const response = await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items: [{ id: Number(id), quantity: 1 }] }),
          });
          if (!response.ok) throw new Error('Add failed');
          document.documentElement.dispatchEvent(new Event('cart:refresh'));
          const drawer = document.querySelector('theme-drawer[data-drawer="cart"], cart-drawer-component, theme-drawer');
          drawer?.open?.();
        } catch (error) {
          console.error(error);
        } finally {
          button.disabled = false;
        }
      });
    });
  });


  // Exclusive FAQ accordion - only one answer open at a time. Modern browsers do
  // this natively via name="" on <details>; this covers older ones only.
  (() => {
    if ('name' in HTMLDetailsElement.prototype) return;

    const wire = (root) => {
      (root || document).querySelectorAll('.buy-box__faq').forEach((group) => {
        const items = group.querySelectorAll('.buy-box__faq-item');
        items.forEach((item) => {
          item.addEventListener('toggle', () => {
            if (!item.open) return;
            items.forEach((other) => {
              if (other !== item) other.open = false;
            });
          });
        });
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => wire());
    } else {
      wire();
    }
    document.addEventListener('shopify:section:load', (event) => wire(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["faq-section"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if ('name' in document.createElement('details')) return;
    document.querySelectorAll('.faq-section__list').forEach(function (group) {
      var items = group.querySelectorAll('.faq-section__item');
      items.forEach(function (item) {
        item.addEventListener('toggle', function () {
          if (!item.open) return;
          items.forEach(function (other) {
            if (other !== item) other.open = false;
          });
        });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
